import type { UserMap } from '~/models'

type MapCenterLike =
  | {
      lat: number
      lng: number
    }
  | {
      lat: () => number
      lng: () => number
    }

export type MapHomeSource = {
  getCenter: () => MapCenterLike | null | undefined
  getZoom: () => number | undefined
}

function hasLatLngMethods(
  center: MapCenterLike
): center is { lat: () => number; lng: () => number } {
  return typeof center.lat === 'function' && typeof center.lng === 'function'
}

function getCenterValue(center: MapCenterLike) {
  if (hasLatLngMethods(center)) {
    return {
      latitude: center.lat(),
      longitude: center.lng(),
    }
  }

  return {
    latitude: center.lat,
    longitude: center.lng,
  }
}

export function getMapHomeViewState(
  map: MapHomeSource
): UserMap['initialViewState'] | null {
  const center = map.getCenter()
  const zoom = map.getZoom()

  if (!center || typeof zoom !== 'number') return null

  return {
    ...getCenterValue(center),
    zoom,
  }
}
